export enum TypingFormat {
    IntegerNumbersOnly = 1,
    DecimalNumbersOnly = 2
}
